import * as React from 'react';
import { cn } from '@companion-professional/webutils';

export const CardFooter = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => <div ref={ref} className={cn('flex items-center p-5 pt-0 md:p-6 md:pt-0', className)} {...props} />
);
CardFooter.displayName = 'CardFooter';
